import React from 'react';
import moment from 'moment';
import { IoSearch } from 'react-icons/io5';

function EmptyDayBar({ date, dateFrom, dateTo, handleBarChoose }) {
  let dateText = moment(date, 'DD.MM.YYYY').format('DD');
  let weekDay = moment(date, 'DD.MM.YYYY').format('dd');
  let monthInfo = moment(date, 'DD.MM.YYYY').format('MMMM YYYY');
  const chosen = dateFrom === date || dateTo === date;
  const startOfMonth = dateText === '01';
  const barHeight = 30;
  return (
    <div
      className="graph__item"
      title={`${date}, цена неизвестна`}
      onClick={() => handleBarChoose(date)}
    >
      {startOfMonth ? (
        <div
          className="graph__item-month"
          style={{
            height: `calc(120px - ${barHeight}px)`,
          }}
        >
          {monthInfo}
        </div>
      ) : null}
      <div
        className={`graph__item-price-popup${
          chosen ? ' graph__item-price-popup_visible' : ''
        }`}
        style={{
          transform: `translateY(${100 - barHeight}px)`,
        }}
      >
        Цена неизвестна
      </div>
      <div className="graph__item-bar-container">
        <div
          className={`graph__item-bar graph__item-bar_price-unknown${
            chosen ? ' graph__item-bar_chosen' : ''
          }`}
          style={{ height: `${barHeight}%` }}
        >
          <IoSearch />
        </div>
      </div>
      <div className="graph__item-labels">
        <p className="graph__item-label">{dateText}</p>
        <p className="graph__item-label">{weekDay}</p>
      </div>
    </div>
  );
}

export default EmptyDayBar;
